import { ArrowBackIos, Circle, GroupOutlined, ListAlt, Payment, PinDropOutlined } from "@mui/icons-material";
import { Box, Button, Checkbox, CircularProgress, Divider, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { SuccessAlert } from "../common/snackbar/success";
import { ErrorAlert } from "../common/snackbar/error";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import imagePlaceHolder from './../../images/img-placeholder.svg';
import { HttpRequest } from "../HttpRequest";
import capitalizeFirstLetter from "../common/capitalize";
import secureLocalStorage from "react-secure-storage";
import OrderStatus from "./orderStatus";
import { getOrderStatusColor } from "./orderStatusColor";


const OrderDetails = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [successShow, setSuccessShow] = useState({ state: false, message: "" })
    const [errorShow, setErrorShow] = useState({ state: false, message: "" })
    const navigate = useNavigate();
    const { orderId } = useParams();
    const [order, setOrder] = useState({});
    const [customer, setCustomer] = useState({});
    const [loading, setLoading] = useState(false);
    const [pushyId, setPushyId] = useState('');
    const [orderPaymentDetails, setOrderPaymentDetails] = useState({});
    const [selected, setSelected] = useState([]);
    const isSelected = (id) => selected.indexOf(id) !== -1;

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const month = months[date.getMonth()];
        const day = date.getDate();
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        return `${month} ${day}, ${year} ${formattedHours}:${formattedMinutes}${ampm}`;
    };
    const getOrderDetails = () => {
        setLoading(true);
        HttpRequest({
            method: 'GET',
            url: `/api/v1/ecommerce/getzedecommerce-order-byid?orderId=${orderId}`,
        }).then((data) => {
            if (data.status === 200) {
                setOrder(data.response.data);
                setPushyId()
            }
        }).catch((error) => {
        }).finally(() => {
            setLoading(false);
        })
    }
    const getCustomerDetails = () => {
        HttpRequest({
            method: 'GET',
            url: `/api/get_parentcustomer_data?customerId=${order?.customerId ? order?.customerId:order?.userId}`
        }).then((data) => {
            setCustomer(data.response.data);
        }).catch((error) => {
        });
    }
    const handleChangeStatus = (status) => {
        HttpRequest({
            method: 'POST',
            url: `/api/v1/ecommerce/adminupdateorderbystatus`,
            body: {
                "orderId": order?._id,
                "orderStatus": status
            }
        }).then((data) => {
            if (data.status === 200) {
                setSuccessShow({ state: true, message: data.response.message });
                setOrder(data.response.data);
            } else {
                const message = data.response.message;
                setErrorShow({ state: true, message });
            }
        }).catch((error) => {
        });
    }
    const calculateShippingAmount = (items) => {
        if (!Array.isArray(items) || items.length === 0) {
            return 0;
        }

        const totalItemAmount = items?.reduce((total, currentItem) => {
            if (currentItem?.additionalItems && currentItem?.additionalItems.length > 0) {
                total += currentItem.additionalItems.reduce((additionalTotal, additionalItem) => {
                    additionalTotal += additionalItem.itemAmount;
                    return additionalTotal;
                }, 0);
            }

            return total;
        }, 0);

        return totalItemAmount;
    };
    const getOrderPaymentDetails = () => {
        HttpRequest({
            method: 'POST',
            url: `/api/order_payment_status`,
            body: {
                "pushyTransactionId": orderId,
                "businessNo": secureLocalStorage.getItem("businessId"),
            }
        }).then(async (data) => {
            setOrderPaymentDetails(data.response.order);

        }).catch((error) => {
        });
    }

    useEffect(() => {
        getOrderDetails();
    }, [])
    useEffect(() => {
        getOrderDetails();
    }, [orderId]);
    useEffect(() => {
        getCustomerDetails();
        if (order?._id !== '') {
            getOrderPaymentDetails();
        }
    }, [order]);
    const totalItems = order?.items?.reduce((sum, item) => {
        return sum + item.itemCount;
    }, 0);

    const handleClick = (event, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };
    const getButtonProps = (orderStatus, deliveryMethod) => {
        if (!orderStatus || !deliveryMethod) {
            return null; 
        }
    
        if (orderStatus === 'Delivered') {
            return null; 
        }
    
        const statuses = {
            ship: {
                Received: { label: 'Process Order', nextStatus: 'Processing', color: '#032541' },
                Processing: { label: 'Ready To Ship', nextStatus: 'ReadyToShip', color: '#032541' },
                ReadyToShip: { label: 'Ship Order', nextStatus: 'Shipped', color: '#032541' },
                Shipped: { label: 'Mark as Delivered', nextStatus: 'Delivered', color: '#17ae7b' },
                Pending: { label: 'Mark as Received', nextStatus: 'Received', color: '#032541' },
            },
            pickup: {
                Received: { label: 'Process Order', nextStatus: 'Processing', color: '#032541' },
                Processing: { label: 'Ready for Pickup', nextStatus: 'ReadyToShip', color: '#032541' },
                ReadyToShip: { label: 'Mark as Picked Up', nextStatus: 'Delivered', color: '#032541' },
                Pending: { label: 'Mark as Received', nextStatus: 'Received', color: '#032541' },
            }
        };
    
        const deliveryStatuses = statuses[deliveryMethod];
        if (!deliveryStatuses) {
            return null; 
        }
    
        return deliveryStatuses[orderStatus] || { label: 'Mark as Received', nextStatus: 'Received', color: '#032541' };
    };
    const buttonProps = getButtonProps(order?.orderStatus, order?.deliveryMethod);
    
    return (
        <div>
            <Box sx={{ width: { xs: "90vw", sm: "calc(100vw - 360px)"}}}>
            <SuccessAlert vertical="top" horizontal="right" onClose={() => setSuccessShow({ ...successShow, state: false })} open={successShow.state} message={successShow.message} />
            <ErrorAlert vertical="top" horizontal="right" onClose={() => setErrorShow({ ...errorShow, state: false })} open={errorShow.state} message={errorShow.message} />
            <div style={{ marginTop: isMobile ? "10%" : "4%", marginLeft: isMobile ? "-20px" : "0" }}>
                <Box sx={{ display: 'flex' }}>
                    <ArrowBackIos sx={{ width: isMobile ? '20px' : '30px', height: isMobile ? '30px' : '50px' }} onClick={() => navigate(-1)} />
                    <Typography variant="h4" sx={{ color: "#032541", fontSize: isMobile ? "20px" : "28px", fontStyle: "normal", fontWeight: "600", margin: isMobile ? '4px 0 4px 10px' : '7px 15px 4px 0' }}>
                        Order Details
                    </Typography>
                </Box>
                {loading &&
                    <Box sx={{ display: 'flex', width: '100%', textAlign: 'center', alignContent: 'center', verticalAlign: 'middle', maxWidth: '774px', margin: '10% 50%' }}>
                        <CircularProgress />
                    </Box>
                }
                {!loading &&
                    <Box>
                        <Box sx={{ display: "flex", flexDirection: isMobile ? "column" : "row", justifyContent: "space-between", alignItems: isMobile ? "flex-start" : "center", mt: '1%', gap: isMobile ? 2 : 0 }}>
                            <Box sx={{ flexDirection: "column" }}>
                                <Box>
                                    <Typography sx={{ margin: '0 0 2px', fontFamily: 'Poppins', fontWeight: 600, textAlign: 'left', color: '#032541', fontSize: isMobile ? '18px' : '22px' }}>Order ID #{order?.orderNumber}</Typography>
                                    <Typography sx={{ margin: '2px 3px 0 0', fontFamily: 'Poppins', fontSize: isMobile ? '12px' : '14px', textAlign: 'left', color: '#707070' }}>Ordered on {formatDate(order?.transtime)}</Typography>
                                </Box>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? 2 : 4, width: isMobile ? '100%' : 'auto' }}>
                                <Box sx={{ marginRight: isMobile ? '0' : '6%' }}>
                                    <Typography sx={{ margin: '0 26px 1px 0', fontFamily: 'Poppins', fontWeight: 'normal', textAlign: 'left', color: '#032541', fontSize: isMobile ? '12px' : '14px' }}>Order Status</Typography>
                                    <Box sx={{ display: 'flex', }}>
                                        <Circle sx={{ color: getOrderStatusColor(order?.orderStatus), margin: '0px 4px 5px 0', fontSize: isMobile ? '14px' : '18px', mt:0.5 }} />
                                        <OrderStatus orderStatus={order?.orderStatus} deliveryMethod={order?.deliveryMethod || 'ship'} />
                                    </Box>
                                </Box>
                            <Box sx={{ marginRight: isMobile ? '0' : '6%' }}>
                                <Typography sx={{ margin: '0 26px 1px 0', fontFamily: 'Poppins', fontWeight: 'normal', textAlign: 'left', color: '#032541', fontSize: isMobile ? '12px' : '14px' }}>Is a Preorder</Typography>
                                <Box sx={{ display: 'flex' }}>
                                    <Circle sx={{ color: order?.isOrderPreorder ? '#17ae7b' : '#dc3545', margin: '5px 4px 5px 0', fontSize: isMobile ? '14px' : '18px' }} />
                                    <Typography sx={{ margin: '0 0 0 4px', fontSize: isMobile ? '14px' : '18px', fontWeight: 600, color: order?.isOrderPreorder ? '#17ae7b' : '#dc3545' }}>{order?.isOrderPreorder ? 'Yes' : 'No'}</Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                        <Divider sx={{ width: '100%', height: '1px', margin: '19.5px 0 20.5px 0.5px', backgroundColor: ' rgba(0, 0, 0, 0.12)' }} />
                        <Grid container spacing={3}>
                        {/* Customer Details */}
                        <Grid item xs={12} md={6} lg={3}>
                            <Box sx={{ p: 2.5, borderRadius: 2, border: '1px solid', borderColor: 'divider', backgroundColor: 'white', height: '100%'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2.5 }}>
                                <GroupOutlined sx={{ color: '#032541', mr: 1.5, fontSize: '20px' }} />
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: '16px', fontWeight: 600, color: '#032541' }}>Customer Details</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <Box>
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: '12px', fontWeight: 600, color: '#666', textTransform: 'uppercase', letterSpacing: 0.5, mb: 0.5}}> Name</Typography>
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: '14px', color: '#032541',fontWeight: 500}}> {order?.customerName || 'N/A'}</Typography>
                                </Box>
                                <Box>
                        <       Typography sx={{ fontFamily: 'Poppins', fontSize: '12px', fontWeight: 600, color: '#666',textTransform: 'uppercase', letterSpacing: 0.5, mb: 0.5}}>Email</Typography>
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: '14px', color: '#032541', wordBreak: 'break-all'}}> {customer?.email || 'N/A'}</Typography>
                                </Box>
                                <Box>
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: '12px', fontWeight: 600, color: '#666', textTransform: 'uppercase', letterSpacing: 0.5, mb: 0.5}}> Phone</Typography>
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: '14px', color: '#032541',fontWeight: 500}}> +{customer?.phone || 'N/A'}</Typography>
                                </Box>
                            </Box>
                            </Box>
                        </Grid>
                        {/* Order Details */}
                        <Grid item xs={12} md={6} lg={3}>
                            <Box sx={{ p: 2.5, borderRadius: 2, border: '1px solid', borderColor: 'divider', backgroundColor: 'white', height: '100%'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2.5 }}>
                                <ListAlt sx={{ color: '#032541', mr: 1.5, fontSize: '20px' }} />
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: '16px', fontWeight: 600, color: '#032541' }}> Order Details</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                {[
                                { label: 'Payment', value: order?.status || 'N/A',  color: order?.status === "paid" ? '#17ae7b' : '#dc3545', bold: true},
                                { label: 'Items', value: totalItems || '0', color: '#032541' },
                                { label: 'Amount', value: `Ksh ${order?.orderAmountExclDelivery || '0'}`, color: '#032541' },
                                { label: 'Delivery', value: `Ksh ${order?.shippingAmount || '0'}`, color: '#032541' },
                                { label: 'Customization', value: `Ksh ${order?.items ? calculateShippingAmount(order?.items) : 0}`, color: '#032541' },
                                ].map((item, index) => (
                                <Box key={index} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography sx={{ fontFamily: 'Poppins', fontSize: '13px', color: '#666',fontWeight: 500}}> {item.label}</Typography>
                                    <Typography sx={{ fontFamily: 'Poppins', fontSize: '13px', color: item.color,fontWeight: item.bold ? 600 : 500,textTransform: 'uppercase'}}> {item.value}</Typography>
                                </Box>
                                ))}
                                <Divider sx={{ my: 1 }} />
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: '14px', fontWeight: 700, color: '#032541'}}> Total Amount </Typography>
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: '14px', fontWeight: 700, color: '#032541' }}> Ksh {order?.transamount || '0'}</Typography>
                                </Box>
                            </Box>
                            </Box>
                        </Grid>
                        {/* Payment Details */}
                        <Grid item xs={12} md={6} lg={3}>
                            <Box sx={{ p: 2.5, borderRadius: 2, border: '1px solid', borderColor: 'divider',backgroundColor: 'white',height: '100%'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2.5 }}>
                                <Payment sx={{ color: '#032541', mr: 1.5, fontSize: '20px' }} />
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: '16px', fontWeight: 600, color: '#032541' }}> Payment Details</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <Box>
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: '12px', fontWeight: 600, color: '#666', textTransform: 'uppercase', letterSpacing: 0.5, mb: 0.5}}> Payment Reference </Typography>
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: '13px', color: '#032541',wordBreak: 'break-all', fontWeight: 500}}> {orderPaymentDetails?.transactionId || 'N/A'}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: '13px', color: '#666', fontWeight: 500}}> Payment Method</Typography>
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: '13px', color: '#032541', fontWeight: 500,textTransform: 'capitalize'}}> {orderPaymentDetails?.paymentMethod || 'N/A'} </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: '13px', color: '#666',fontWeight: 500}}> Phone Number</Typography>
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: '13px', color: '#032541', fontWeight: 500}}> {orderPaymentDetails?.stkPhone || 'N/A'}</Typography>
                                </Box>
                            </Box>
                            </Box>
                        </Grid>
                        {/* Delivery Address */}
                        <Grid item xs={12} md={6} lg={3}>
                            <Box sx={{ p: 2.5, borderRadius: 2, border: '1px solid', borderColor: 'divider',backgroundColor: 'white',height: '100%'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2.5 }}>
                                <PinDropOutlined sx={{ color: '#032541', mr: 1.5, fontSize: '20px' }} />
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: '16px', fontWeight: 600, color: '#032541' }}> Delivery Address</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <Box>
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: '12px', fontWeight: 600, color: '#666',textTransform: 'uppercase',letterSpacing: 0.5,mb: 0.5}}> Delivery Method</Typography>
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: '14px', color: '#032541',fontWeight: 500,textTransform: 'capitalize'}}> {capitalizeFirstLetter(order?.deliveryMethod) || 'N/A'} </Typography>
                                </Box>
                                <Box>
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: '12px', fontWeight: 600, color: '#666', textTransform: 'uppercase',letterSpacing: 0.5,mb: 0.5}}> {order?.deliveryMethod === 'pickup' ? 'Pickup Location' : 'Shipping Address'} </Typography>
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: '13px', color: '#032541',wordBreak: 'break-word'}}> {order?.deliveryMethod === 'pickup' ? order?.pickUpLocationDetails?.locationName : order?.shippingRegionDetails?.regionDescription || 'N/A'}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: '13px', color: '#666',fontWeight: 500}}> City</Typography>
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: '13px', color: '#032541',fontWeight: 500}}> {customer?.customerpreference?.city || 'N/A'}</Typography>
                                </Box>
                                <Box>
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: '12px', fontWeight: 600, color: '#666',textTransform: 'uppercase',letterSpacing: 0.5,mb: 0.5}}> Address</Typography>
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: '13px', color: '#032541',wordBreak: 'break-word'}}> {customer?.customerpreference?.address || 'N/A'}</Typography>
                                </Box>
                            </Box>
                            </Box>
                        </Grid>
                        </Grid>
                        <Divider sx={{ width: '100%', height: '1px', margin: '64px 0 20.5px 0.5px', backgroundColor: ' rgba(0, 0, 0, 0.12)'}} />
                        <TableContainer sx={{ overflowX: 'auto' }}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ display: isMobile ? 'none' : 'table-cell', height: '20px', fontFamily: 'Poppins', fontSize: '14px', fontWeight: 600, color: '#032541', textAlign: 'left' }}></TableCell>
                                        <TableCell sx={{ height: '20px', fontFamily: 'Poppins', fontSize: '14px', fontWeight: 600, color: '#032541', textAlign: 'left' }}>Product</TableCell>
                                        <TableCell sx={{ display: isMobile ? 'none' : 'table-cell', height: '20px', fontFamily: 'Poppins', fontSize: '14px', fontWeight: 600, color: '#032541', textAlign: 'left' }}>Variations</TableCell>
                                        <TableCell sx={{ height: '20px', fontFamily: 'Poppins', fontSize: '14px', fontWeight: 600, color: '#032541', textAlign: 'left' }}>Price</TableCell>
                                        <TableCell sx={{ height: '20px', fontFamily: 'Poppins', fontSize: '14px', fontWeight: 600, color: '#032541', textAlign: 'left' }}>Quantity</TableCell>
                                        <TableCell sx={{ display: isMobile ? 'none' : 'table-cell', height: '20px', fontFamily: 'Poppins', fontSize: '14px', fontWeight: 600, color: '#032541', textAlign: 'left' }}>Customization</TableCell>
                                        <TableCell sx={{ height: '20px', fontFamily: 'Poppins', fontSize: '14px', fontWeight: 600, color: '#032541', textAlign: 'left' }}>Total</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ padding: '0 0 1px' }}>
                                    {Array.isArray(order?.items) && order?.items.map((row, index) => (
                                        <TableRow key={row?.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell padding="checkbox" sx={{ display: isMobile ? 'none' : 'table-cell' }}>
                                                <Checkbox
                                                    color="primary"
                                                    checked={isSelected(row._id)}
                                                    inputProps={{
                                                        'aria-labelledby': `enhanced-table-checkbox-${index}`,
                                                    }}
                                                    onClick={(event) => handleClick(event, row?._id)}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', alignItems: isMobile ? 'center' : 'flex-start', gap: 1 }}>
                                                    <img src={row?.productImage ?? imagePlaceHolder} alt="" style={{ width: '50px', height: '50px' }} />
                                                    <Typography sx={{ fontFamily: 'Poppins', fontSize: '14px', fontWeight: 500, color: '#000', textAlign: isMobile ? 'center' : 'left' }}>{row?.itemName}</Typography>
                                                </Box>
                                            </TableCell>
                                            <TableCell sx={{ display: isMobile ? 'none' : 'table-cell', fontFamily: 'Poppins', fontSize: '14px', fontWeight: 'normal', color: '#707070' }}>{row?.tags.join(', ')}</TableCell>
                                            <TableCell sx={{ fontFamily: 'Poppins', fontSize: '14px', fontWeight: 'normal', color: '#707070' }}>Ksh {row?.itemAmount / row?.itemCount}</TableCell>
                                            <TableCell sx={{ fontFamily: 'Poppins', fontSize: '14px', fontWeight: 'normal', color: '#707070' }}>{row?.itemCount}</TableCell>
                                            <TableCell sx={{ display: isMobile ? 'none' : 'table-cell', fontFamily: 'Poppins', fontSize: '14px', fontWeight: 'normal', color: '#707070' }}>
                                                {row?.additionalItems?.length > 0 ? row?.additionalItems.map(item => `${item?.itemName}: ${item?.isCustomizableValue}`).join(', ') : 'None'}
                                            </TableCell>
                                            <TableCell sx={{ fontFamily: 'Poppins', fontSize: '14px', fontWeight: 'normal', color: '#707070' }}>Ksh {row?.itemAmount}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {order?.deliveryMethod && order?.status === 'paid' && (
                            <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                               
                                {buttonProps && (
                                    <Button
                                        onClick={() => handleChangeStatus(buttonProps?.nextStatus)}
                                        variant="contained"
                                        sx={{
                                            textTransform: 'capitalize', width: isMobile ? '100%' : '150px', height: '45px',
                                            margin: isMobile ? '25px 0 0 0' : '25px 150px 0 100px', padding: '13px 26px 12px', borderRadius: '5px',
                                            backgroundColor: buttonProps.color, fontFamily: 'Poppins', fontSize: '14px', fontWeight: 500,
                                            textAlign: 'center', color: '#fff', textWrap: 'nowrap'
                                        }}
                                    >
                                        {buttonProps?.label}
                                    </Button>
                                )}
                            </Box>
                        )}

                    </Box>
                }
            </div>
            </Box>
        </div>
    )
}
export default OrderDetails;